//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  data() {
    return {
      currentCol: "",
      soloColOptions: ["Step", "Turn", "Footwork", "Alignment", "Sway"],
      bothColOptions: ["Moving", "Rise & Fall", "Position"],
    };
  },
  computed: {
    options() {
      return this.role === "Both" ? this.bothColOptions : this.soloColOptions;
    },
  },
  props: {
    figure: {
      default: "",
    },
    role: {
      default: "Both",
    },
    currentStep: {
      default: 0,
    },
  },
  methods: {
    selectStep(step) {
      this.currentStep = step;
      this.$emit("changeStep", step);
    },
    handleHeaderChange(value) {
      this.currentCol = value;
      this.$forceUpdate();
    },
    pickColumn(col, step) {
      switch (col) {
        case "Step":
          return step.movement;
        case "Turn":
          return step.turn;
        case "Footwork":
          return step.footwork;
        case "Alignment":
          return step.alignment;
        case "Sway":
          return step.sway;
        case "Rise & Fall":
          return step.risefall;
        case "Moving":
          return step.moving;
        case "Position":
          return step.position;
      }
    },
  },
  watch: {
    role() {
      this.currentCol =
        this.role === "Both" ? this.bothColOptions[0] : this.soloColOptions[0];
    },
  },
  created() {},
  mounted() {
    if (this.role === "Both") {
      this.currentCol = this.bothColOptions[0];
    } else {
      this.currentCol = this.soloColOptions[0];
    }
  },
};
